var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.5024C6.25 11.1414 5.5105 11.4752 5.03275 11.0897L4.96975 11.0327L0.469749 6.53266C0.340616 6.40351 0.263044 6.23169 0.251583 6.04942C0.240122 5.86715 0.29556 5.68696 0.407499 5.54266L0.469749 5.47216L4.96975 0.972156L5.04025 0.909906L5.098 0.869406L5.17 0.828907L5.197 0.816156L5.24725 0.795906L5.32825 0.771906L5.368 0.764406L5.413 0.756906L5.45575 0.753906L5.54425 0.753906L5.58775 0.757656L5.63275 0.764406L5.67175 0.771906L5.75275 0.795906L5.803 0.816156L5.902 0.868657L5.9695 0.917406L6.03025 0.972157L6.0925 1.04266L6.133 1.10041L6.1735 1.17241L6.18625 1.19941L6.2065 1.24966L6.2305 1.33066L6.238 1.37041L6.2455 1.41541L6.2485 1.45816L6.25 10.5024Z",
    fill: "#529CF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).775df5b153a2a62cf478954c3787a0d8.svg";
export { ForwardRef as ReactComponent };